// Method to check users passwords using the Enzoic API for login
async function enzoicPasswordChecker(password) {
  try {
    const response = await fetch('https://enzoic-passwordchecker-api.azurewebsites.net/api/enzoicPasswordChecker?', {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        password: password, // Replace with the actual password
      }),
    });

    const data = await response.json();

    console.log("Enzoic Resonse: ", response);

    return data.result;
  } catch (error) {
    // If there are any errors with Enzoic, send true so we don't lock out the user
    console.error('Error during Enzoic Password Check:', error);
    return true;
  }
}
